// ── OmniLinQ app-role identifiers ──────────────────────────────────────────────
// These MUST match the `value` of each app_role defined in the infra repo:
//   ts-omnilinq-infra/environments/*/infra/appregistration.tf
//     • static app_role "Admin"
//     • local.omnilinq_app_roles.{agent,step,prompt,attributes,tier2,poststep}
// and the per-route enforcement in that repo's apim.tf. Renaming a value in one
// place without the other silently breaks authorization — treat these as a
// contract, not free text.
//
// Authorization is UI-only. The real gate is APIM (validate-jwt + per-route role
// check). Hiding a control here does not protect the underlying operation.

export const Roles = {
  /** Superuser — implicitly grants every permission below. */
  Admin: 'Admin',

  ProductSupportAgent: 'OmniLinQ.ProductSupportAgent',

  StepProductLinq: 'OmniLinQ.StepProductLinq',
  StepPromptConfig: 'OmniLinQ.StepProductLinq.PromptConfig',
  StepAttributes: 'OmniLinQ.StepProductLinq.Attributes',
  StepTier2MasterData: 'OmniLinQ.StepProductLinq.Tier2MasterData',
  /** Sensitive write — posting extracted data into STEP. */
  StepPostToStep: 'OmniLinQ.StepProductLinq.PostToStep',
} as const;

export type Role = (typeof Roles)[keyof typeof Roles];
